import { uniqBy } from "@s-libs/micro-dash";

// Update speech marks to reflect character count rather than byte size.
const processSpeechMarks = (speechMarks, textChunk, offset = 0) => {
  if (!speechMarks) return [];

  // Filter out sentences.
  const wordSpeechMarks = speechMarks.filter(
    (speechMark) => speechMark?.type === "word",
  );

  // Remove duplicate marks.
  // This sometimes occurs with values like "10-15%", where Polly will return speech marks for each number,
  // as wll as one for the entire value.
  const uniqueSpeechMarks = uniqBy(wordSpeechMarks, (x) => x.start);

  let characterCount = offset;
  let currentMark;

  let editedTextChunk = textChunk;

  return uniqueSpeechMarks.map((mark) => {
    const charactersBeforeWord = editedTextChunk.match(/^\W+/)?.[0];

    characterCount = characterCount + (charactersBeforeWord?.length || 0);
    editedTextChunk.replace(charactersBeforeWord, "");
    currentMark = {
      value: mark?.value,
      time: mark?.time,
      start: characterCount,
    };

    const regex = new RegExp(`(\\W+)?${mark?.value}`);
    const currentSentenceValue = editedTextChunk.match(regex)?.[0];
    editedTextChunk = editedTextChunk.replace(currentSentenceValue, "");

    characterCount += mark?.value.length || 0;

    return currentMark;
  });
};

export default processSpeechMarks;
